import { useEndpointFetch } from '../../../../global/network/useEndpointFetch';

export const useApproveRoleApplicationFetch = () => {
  return useEndpointFetch<{ roleApplicationId: string; managerId: string }>('/vm/role-applications/approve');
};

export const useRejectRoleApplicationFetch = () => {
  return useEndpointFetch<{ roleApplicationId: string; managerId: string; reason?: string }>(
    '/vm/role-applications/reject'
  );
};

export const useWithdrawRoleApplicationFetch = () => {
  return useEndpointFetch<{ roleApplicationId: string; userId: string }>('/vm/role-applications/withdraw');
};
